import { initLogin } from './resources/auth/login.js';
import { initLoginPasskey } from './resources/auth/loginPasskey.js';
import { initLogout } from './resources/auth/logout.js';
import { initUserMenu } from './resources/nav/userMenu.js';
import { initGlobalSuche } from './resources/nav/globalSuche.js';
import { initVerwaltungMenu } from './resources/nav/verwaltungMenu.js';
import { initAufgabenGlocke } from './resources/aufgaben/aufgabenGlocke.js';
import { initAufgabeForm } from './resources/aufgaben/aufgabeForm.js';
import { initAufgabeList } from './resources/aufgaben/aufgabeList.js';
import { initAuditList } from './resources/audit/auditList.js';
import { initAvatar } from './resources/settings/avatar.js';
import { initTheme } from './resources/settings/theme.js';
import { initPasskeys } from './resources/settings/passkeys.js';
import { initBerechtigungList } from './resources/handbuch/berechtigungList.js';
import { initFilialeForm } from './resources/filialen/filialeForm.js';
import { initFilialeList } from './resources/filialen/filialeList.js';
import { initKonfigurationForm } from './resources/konfiguration/konfigurationForm.js';
import { initJobDetail } from './resources/jobs/jobDetail.js';
import { initJobForm } from './resources/jobs/jobForm.js';
import { initJobList } from './resources/jobs/jobList.js';
import { initKandidatDetail } from './resources/kandidaten/kandidatDetail.js';
import { initKandidatForm } from './resources/kandidaten/kandidatForm.js';
import { initKandidatList } from './resources/kandidaten/kandidatList.js';
import { initLeadList } from './resources/leads/leadList.js';
import { initLeadForm } from './resources/leads/leadForm.js';
import { initLeadAktionen } from './resources/leads/leadAktionen.js';
import { initKandidatKarte } from './resources/kandidaten/kandidatKarte.js';
import { initKandidatErreichbar } from './resources/kandidaten/kandidatErreichbar.js';
import { initListeAuswahl } from './resources/listen/listeAuswahl.js';
import { initListeErgebnis } from './resources/listen/listeErgebnis.js';
import { initListeForm } from './resources/listen/listeForm.js';
import { initListeList } from './resources/listen/listeList.js';
import { initKandidatenvorschlagInline } from './resources/jobs/kandidatenvorschlagInline.js';
import { initTerminInline } from './resources/jobs/terminInline.js';
import { initAnsprechpersonInline } from './resources/kunden/ansprechpersonInline.js';
import { initDokumentInline } from './resources/dokumente/dokumentInline.js';
import { initKundeDetail } from './resources/kunden/kundeDetail.js';
import { initKundeKarte } from './resources/kunden/kundeKarte.js';
import { initKundeUmkreis } from './resources/kunden/kundeUmkreis.js';
import { initKundeForm } from './resources/kunden/kundeForm.js';
import { initKundeList } from './resources/kunden/kundeList.js';
import { initKundeZuordnung } from './resources/kunden/kundeZuordnung.js';
import { initKundeVerlauf } from './resources/kunden/kundeVerlauf.js';
import { initKundeVerlaufForm } from './resources/kunden/kundeVerlaufForm.js';
import { initKonzernDetail } from './resources/konzerne/konzernDetail.js';
import { initKonzernForm } from './resources/konzerne/konzernForm.js';
import { initKonzernList } from './resources/konzerne/konzernList.js';
import { initInseratPruefung } from './resources/inserate/inseratPruefung.js';
import { initInseratLaeufe } from './resources/inserate/inseratLaeufe.js';
import { initZefixLaeufe } from './resources/zefix/zefixLaeufe.js';
import { initZefixLauf } from './resources/zefix/zefixLauf.js';
import { initZefixFaelle } from './resources/zefix/zefixFaelle.js';
import { initSalesforceStatus } from './resources/salesforce/salesforceStatus.js';
import { initSalesforceAbweichungen } from './resources/salesforce/salesforceAbweichungen.js';
import { initKiKosten } from './resources/ki/kiKosten.js';
import { initSicherungList } from './resources/sicherungen/sicherungList.js';
import { initZeitplanUebersicht } from './resources/zeitplan/zeitplanUebersicht.js';
import { initTicketForm } from './resources/tickets/ticketForm.js';
import { initStammdatenForm } from './resources/stammdaten/stammdatenForm.js';
import { initStammdatenList } from './resources/stammdaten/stammdatenList.js';
import { initUserForm } from './resources/users/userForm.js';
import { initUserList } from './resources/users/userList.js';
import { initFlash } from './shared/flash.js';

initFlash();
initLogin();
initLoginPasskey();
initLogout();
initUserMenu();
initGlobalSuche();
initVerwaltungMenu();
// The bell first, so refreshBadge is wired before a list action calls it.
initAufgabenGlocke();
initAufgabeForm();
initAufgabeList();
initAuditList();
initAvatar();
initTheme();
initPasskeys();
initBerechtigungList();
initFilialeForm();
initFilialeList();
initKonfigurationForm();
initJobDetail();
initJobForm();
initJobList();
initKandidatDetail();
initKandidatForm();
initKandidatList();
initKandidatKarte();
initKandidatErreichbar();
initListeAuswahl();
initListeErgebnis();
initListeForm();
initListeList();
initKandidatenvorschlagInline();
initTerminInline();
initAnsprechpersonInline();
initDokumentInline();
initKundeDetail();
initKundeKarte();
initKundeUmkreis();
initKundeForm();
initKundeList();
initKundeZuordnung();
initLeadList();
initLeadForm();
initLeadAktionen();
initKundeVerlauf();
initKundeVerlaufForm();
initKonzernDetail();
initKonzernForm();
initKonzernList();
initInseratPruefung();
initInseratLaeufe();
initZefixLaeufe();
initZefixLauf();
initZefixFaelle();
initSalesforceStatus();
initSalesforceAbweichungen();
initKiKosten();
initSicherungList();
initZeitplanUebersicht();
initTicketForm();
initStammdatenForm();
initStammdatenList();
initUserForm();
initUserList();
